import { formatDateCustom } from './format-date-custom.js';

/**
 * Format an absolute date, optionally with the day of the week and time component.
 *
 * Use this for UIs where specificity is important, such as on a customer's order receipt.
 *
 * Defaults:
 * - `format` = "short"
 * - `includeDayOfWeek` = "false"
 * - `includeTime` = "false"
 * - `ianaTimeZone` = "undefined"
 */
function formatDate(date, options) {
    return formatDateCustom(date, Object.assign(Object.assign({}, options), { includeYear: true }));
}

export { formatDate };
//# sourceMappingURL=format-date.js.map
